import React, { FC } from "react";
import { useEffectOnce } from "react-use";
import { useAuthContext } from "../../features/auth/model/useAuthContext";
import Box from "../../shared/ui/display/Box";
import CircularProgress from "../../shared/ui/feedback/CircularProgress";
import { useUIContext } from "../../shared/ui/contexts/UIContext";
import checkIsCheckInApp from "../../shared/lib/checkIsCheckInApp";
import CheckInAppRoot from "./CheckInAppRoot";
import CustomerPortalAppRoot from "./CustomerPortalAppRoot";

const Root: FC = () => {
  const { isUserLoaded, userData } = useAuthContext();
  const { setSubdomain } = useUIContext();
  const subdomain = window.location.hostname.split(".")[0];
  useEffectOnce(() => {
    setSubdomain(subdomain);
  });
  const isCheckInApp = checkIsCheckInApp(subdomain);

  if (!isUserLoaded) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
        pt={10}
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isCheckInApp) {
    return <CheckInAppRoot userData={userData} />;
  }

  return <CustomerPortalAppRoot userData={userData} />;
};

export default Root;
